var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrInput',_vm._g(_vm._b({class:_vm.classList,attrs:{"label":_vm.label,"prepend-icon":"search"},on:{"input":_vm.emitInput},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'SrInput',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }